// extracted by mini-css-extract-plugin
export default {"wrapperMenu":"MainPage_wrapperMenu__63PqG","logoutIcon":"MainPage_logoutIcon__Cbvw4","wrapperPages":"MainPage_wrapperPages__rIQaB"};